import { DialogTitle, Grid } from '@mui/material';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ClientDTO, getClientById } from 'wisestep-api';
import { WsButton, WsDialog, WsIconCross, WsTypography, WsTypoVariants } from 'wisestep-base';

import ClientDetailsFormNew from '../../../../features/clientListingPage/components/ClientDetailsFormNew';
import ClientStatusPopUpForm from '../../../../features/clientListingPage/components/ClientStatusPopUpForm';
import { defaultClientDTO } from '../../../clientListingPage/helper/ClientListingHelper';
export interface DialogProps {
  open: boolean;
  clientNameInputVal: string;
  onClose: Dispatch<SetStateAction<boolean>>;
  onSelect: (client: ClientDTO) => void;
  isMarkInactive?: boolean;
}

const CreateNewClientDialog = ({
  open,
  clientNameInputVal,
  onClose,
  onSelect,
  isMarkInactive,
}: DialogProps) => {
  const [clientDTO, setClientDTO] = useState<ClientDTO>();

  useEffect(() => {
    const loadClient = async () => {
      const res = await getClientById(clientNameInputVal);
      setClientDTO(res.data.data);
    };
    loadClient();
  }, [clientNameInputVal]);

  return (
    <WsDialog openDialog={open} size={isMarkInactive ? 'small' : 'medium'}>
      <DialogTitle>
        <Grid item container justifyContent="space-between">
          <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
            {isMarkInactive ? 'Update Client Status' : 'Create Client'}
          </WsTypography>
          <WsButton startIcon={<WsIconCross />} onClick={() => onClose(false)} variant="text">
            Close
          </WsButton>
          {isMarkInactive && (
            <WsTypography variant={WsTypoVariants.BODY1}>
              {`The client you are trying to select is marked "Inactive". Please select the status type
              as non "Inactive" to select the client.`}
            </WsTypography>
          )}
        </Grid>
      </DialogTitle>
      <Grid p={2}>
        {isMarkInactive ? (
          clientDTO && (
            <ClientStatusPopUpForm
              source="JobPostingForm"
              defaultValues={clientDTO}
              getClient={onSelect}
              onClose={onClose}
            />
          )
        ) : (
          <ClientDetailsFormNew
            source="ClientAdditionForm"
            client={{ ...defaultClientDTO, name: clientNameInputVal?.trim() }}
            setClient={onSelect}
          />
        )}
      </Grid>
    </WsDialog>
  );
};

export default CreateNewClientDialog;
